import { Injectable } from '@angular/core';
import { Parameter } from 'projects/common/src/app/classes';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { CommunicationService } from 'src/app/services/communication';
import { UserDataService } from '../user-data/user-data.service';
import { IShift } from '../../../interfaces';
import { MachineCollectionService } from '../machine-collection/machine-collection.service';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class MachineContextService extends Parameter<IMachineContext> {
  private baseUrl: string;

  constructor(
    private communication: CommunicationService,
    private userData: UserDataService,
    private machineCollectionService: MachineCollectionService,
    private urlBuilderService: UrlBuilderService,
  ) {
    super();
    this.name = 'machine-context';
    this.target = {
      name: null,
      numerator: null,
      denominator: null,
    };
    this.baseUrl = this.urlBuilderService.serverBasePath;
  }

  public setMachine(machine: string): Promise<IMachineContext> {
    return new Promise((resolve) => {
      const companyId = this.userData.get().company.id;
      const url = `${this.baseUrl}/shift/GetDefaultShiftByCompany`;
      let currentMachine: IMachineContext = null;

      if (this.machineCollectionService.get() && this.machineCollectionService.get().length > 0) {
        currentMachine = this.machineCollectionService.get().find((value) => value.name.toLowerCase() === machine.toLowerCase());
      }

      // Verificar si los turnos ya están en sessionStorage
      const storedShifts = sessionStorage.getItem('shift-collection');
      if (storedShifts) {
        try {
          const response: IShift[] = JSON.parse(storedShifts);
          this.updateMachineContext(machine, response, currentMachine);
          resolve(this.get());
        } catch (e) {
          console.error('Error parsing sessionStorage shifts:', e);
          this.updateMachineContext(machine, [], currentMachine);
          resolve(this.get());
        }
      } else {
        // Si no están en sessionStorage, consultar el endpoint
        const params = { companyId };
        this.communication.get(url, params).subscribe(
          (response: IShift[]) => {
            if (Array.isArray(response) && response.length) {
              // Guardar en sessionStorage para futuras consultas
              sessionStorage.setItem('shift-collection', JSON.stringify(response)); // Asegurar persistencia
              this.updateMachineContext(machine, response, currentMachine);
            }
            resolve(this.get());
          },
          (error) => {
            console.error('Error fetching shifts:', error);
            this.updateMachineContext(machine, [], currentMachine);
            resolve(this.get());
          },
        );
      }
    });
  }

  private updateMachineContext(machine: string, shifts: IShift[], currentMachine: IMachineContext): void {
    if (Array.isArray(shifts) && shifts.length) {
      this.set({
        name: machine,
        numerator: shifts[0].numerator,
        denominator: shifts[0].denominator,
        code: currentMachine?.code || null,
        machineTypeId: currentMachine?.machineTypeId || null,
        hasProduction: currentMachine?.hasProduction || null,
      });
    } else {
      this.set({
        name: machine,
        numerator: null,
        denominator: null,
        code: currentMachine?.code || null,
        machineTypeId: currentMachine?.machineTypeId || null,
        hasProduction: currentMachine?.hasProduction || null,
      });
    }
  }

  public machine(): string {
    if (this.get()) {
      return this.get().name;
    }
    return null;
  }

  public numerator(): string {
    if (this.get()) {
      return this.get().numerator;
    }
    return null;
  }

  public denominator(): string {
    if (this.get()) {
      return this.get().denominator;
    }
    return null;
  }
}
